/**
 * Copy Link Component.
 */
import { updateLabel } from './update-label.js';

/**
 * Set up the copy link functionality.
 *
 * @param {HTMLElement} copyLinkButton The copy link button element.
 */
export function setupCopyLink( copyLinkButton ) {
	if ( ! copyLinkButton ) {
		return;
	}

	/**
	 * Copy the permalink to the clipboard.
	 *
	 * @param {Event} e The click event.
	 * @returns {Promise<void>}
	 */
	const copyItem = async ( e ) => {
		e.preventDefault();
		const target = e.currentTarget;
		const permalink = target.getAttribute( 'data-permalink' );

		if ( copyLinkButton.classList.contains( 'active' ) ) return;

		if ( ! navigator.clipboard ) {

			let textArea = document.createElement( 'textarea' );
			textArea.value = permalink;
			textArea.select();
			try {
				document.execCommand( 'copy' );
				updateLabel( target, 'Link Copied!' );
			} catch ( err ) {
				console.error( 'Failed to copy!', err );
			}

			return;
		}

		try {
			await navigator.clipboard.writeText( permalink );
			updateLabel( target, 'Link Copied!' );
		} catch ( err ) {
			console.error( 'Failed to copy!', err );
		}
	};

	copyLinkButton.addEventListener( 'click', copyItem );
}
